import React, { useContext, useState, Fragment, useEffect } from "react";
import card_credit from "../img/card_credit.jpg";
import Cvc from "../img/icon/cvc.png";
import Bank from "../img/bank-transfer.png";
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { DataContext, useAuth } from "../context/contextAPI";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";

const PaymentForm = ({
  cartItems,
  fName,
  lName,
  address,
  city,
  postal,
  country,
  phone,
  email,
  pwd,
  methodPayment
}) => {
  const { total, clearCart } = useContext(DataContext);
  const { isAuthenticated } = useAuth();
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  let [isOpen, setIsOpen] = useState(false);
  const [role] = useState('Utilisateur');

  function closeModal() {
    setTimeout(() => {
      setLoading(true);
    }, 3000);
    navigate("/produits");
  }

  function openModal() {
    setIsOpen(true);
  }

  const generateInvoiceNumber = () => {
    const randomNumber = Math.floor(100000000 + Math.random() * 900000000);
    return `${randomNumber}`;
  };

  const generateReferralCode = (uid) => {
    return uid.slice(0, 8);
  };

  const invoiceNumber = generateInvoiceNumber();
  let [numFact, setNumFact] = useState('')
  let [montantPay, setMontantPay] = useState(0)
  let [modePay, setModePay] = useState('')

  const handlePay = async (e) => {
    e.preventDefault();
    
    const full_name = `${fName} ${lName}`;
    setLoading(true);
    setNumFact(invoiceNumber)
    setModePay(methodPayment)

    try {
        let userPay = null;
        if (!isAuthenticated) {
            const userCredential = await createUserWithEmailAndPassword(auth, email, pwd);
            userPay = userCredential.user;

            const referralCode = generateReferralCode(userPay.uid);
            await setDoc(doc(db, "Users", userPay.uid), {
                email: userPay.email,
                phone: phone,
                firstName: fName,
                lastName: lName,
                address: address,
                city: city,
                postal: postal,
                country: country,
                roles: role,
                referralCode: referralCode,
                referredBy: null,
                referrals: [],
                dateCreated: new Date(),
            });
        } else {
            const authent = getAuth();
            userPay = authent.currentUser;
        }

        if (methodPayment === 'Stripe') {
          if (!stripe || !elements) {
              return;
          }

          const cardNumberElement = elements.getElement(CardNumberElement);

          const { error, paymentMethod } = await stripe.createPaymentMethod({
              type: "card",
              card: cardNumberElement,
              billing_details: {
                  name: full_name,
                  phone: phone,
                  email: email,
                  address: {
                      line1: address,
                      city: city,
                      postal_code: postal,
                  },
              },
          });

          if (error) {
              console.error(error);
              setLoading(false);
              return;
          }

          const response = await fetch(
            "https://server-ecokaz.vercel.app/api/paiement",
              // "http://localhost:8000/api/paiement",
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                      montant: total * 100,
                      token: paymentMethod.id,
                  }),
              }
          );

          if (response.ok) {
            const paymentResponse = await response.json();

            await addDoc(collection(db, "payments"), {
              paymentId: paymentMethod.id,
              items: cartItems,
              fullName_ship: full_name,
              address_ship: address,
              city_ship: city,
              postal_ship: postal,
              country_ship: country,
              phone_ship: phone,
              email_ship: email,
              amount: paymentResponse.paiement.amount,
              currency: paymentResponse.paiement.currency,
              status: paymentResponse.paiement.status,
              payment_method: methodPayment,
              userId: userPay ? userPay.uid : null,
              num_facture: invoiceNumber,
              createdAt: new Date(),
            });
          }

          clearCart();
          localStorage.removeItem("dataCart");
          localStorage.removeItem("dataTotal");
          localStorage.removeItem("disabledButtons");
          setLoading(false);
          openModal();
        }else{
          await addDoc(collection(db, "payments"), {
            items: cartItems,
            fullName_ship: full_name,
            address_ship: address,
            city_ship: city,
            postal_ship: postal,
            country_ship: country,
            phone_ship: phone,
            email_ship: email,
            amount: total * 100,
            currency: 'MUR',
            status: 'pending',
            payment_method: methodPayment,
            userId: userPay ? userPay.uid : null,
            num_facture: invoiceNumber,
            createdAt: new Date(),
          });

          clearCart();
          localStorage.removeItem("dataCart");
          localStorage.removeItem("dataTotal");
          localStorage.removeItem("disabledButtons");
          setLoading(false);
          openModal();
        }
    } catch (err) {
        console.error("Error: ", err);
        setLoading(false);
    }
};

const formatDate = (seconds) => {
  const date = new Date(seconds);
  const options = { day: "numeric", month: "long", year: "numeric" };
  const dateString = date.toLocaleDateString("fr-FR", options);
  return `${dateString}`;
};

  return (
    <>
      <ToastContainer />
      <div className="max-w-lg mx-auto mt-8">
        {methodPayment ==='Stripe' ? (
        <>
        <label className="block mb-1 text-gray-700 poppins-semibold">
          Numéro de carte
        </label>
        <div className="flex items-center relative mb-2">
          <img
            src={card_credit}
            alt="icon"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 h-6"
          />
          <CardNumberElement className="border rounded-md text-sm px-3 py-3 flex-1 pe-12" />
        </div>

        <label className="block mb-1 text-gray-700 poppins-semibold">
          Date d'expiration
        </label>
        <CardExpiryElement className="border rounded-md text-sm px-3 py-3 mb-4" />

        <label className="block mb-1 text-gray-700 poppins-semibold">CVC</label>
        <div className="flex items-center relative ">
          <img
            src={Cvc}
            alt="icon"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 h-6"
          />
          <CardCvcElement className="border rounded-md text-sm px-3 py-3 flex-1 pe-12" />
        </div>
        </>
        ):(
          <>
            <img src={Bank} alt='Bank' width={100} className="mx-auto" />
            <ul class="mt-3 divide-y rounded bg-gray-100 py-2 px-3 text-gray-600 shadow-sm hover:text-gray-700 hover:shadow">
              <li class="flex items-center py-3 text-sm">
                <span>E-mail</span>
                <span class="ml-auto poppins-semibold">{email}</span>
              </li><li class="flex items-center py-3 text-sm">
                <span>Téléphone</span>
                <span class="ml-auto">{phone}</span>
              </li>
              <li class="flex items-center py-3 text-sm">
                <span>Mode de paiement</span>
                <span class="ml-auto text-pink-600 poppins-semibold">{methodPayment}</span>
              </li>
              <li class="flex items-center py-3 text-sm">
                <span>Rejoint le</span>
                <span class="ml-auto">{formatDate(new Date())}</span>
              </li>
            </ul>
            <div class="bg-blue-100 text-blue-600 p-4 rounded-lg mt-4 text-xs" role="alert">
              <ul className="space-y-1">
                <li>
                  <span>
                    Veuillez envoyer de l'argent sur notre compte bancaire: <br/><span className="poppins-semibold">00009 - 05042 24550580005 23</span>
                  </span>
                </li>
                <li>
                  <span>
                    Montant du virement bancaire: <span className="poppins-semibold">{total} MGA</span>
                  </span>
                </li>
              </ul>
            </div>
          </>
        )}

        <button
          type="submit"
          className={`w-full flex justify-center py-2 px-4 border border-transparent poppins-bold rounded-md text-white focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out mt-5 ${
            loading
              ? "bg-pink-300 cursor-not-allowed"
              : "bg-black hover:bg-pink-700 cursor-pointer"
          }`}
          onClick={handlePay}
          disabled={loading}
        >
          {loading ? (
            <span className="loading loading-dots loading-md"></span>
          ) : (
            <span>Payer</span>
          )}
        </button>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/60" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-2 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-2 py-5 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-2xl poppins-bold leading-6 text-pink-600 text-center uppercase"
                  >
                    Paiement réussi
                  </Dialog.Title>
                  <div class="bg-white p-2 md:mx-auto mt-1">
                    <svg
                      viewBox="0 0 24 24"
                      class="text-green-600 w-20 h-20 mx-auto my-6"
                    >
                      <path
                        fill="currentColor"
                        d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
                      ></path>
                    </svg>
                    <div class="text-center">
                      <h3 class="md:text-xl text-base text-gray-900 poppins-semibold text-center">
                        Votre commande est passée avec succès
                      </h3>
                      <p class="text-gray-600 my-3">
                        Merci d'avoir acheté nos produits!
                      </p>
                    </div>
                    {modePay === 'Virement' &&
                      (
                        <div class="bg-blue-100 text-blue-600 p-4 rounded-lg mt-4 text-xs" role="alert">
                          <ul className="space-y-1">
                            <li>
                              <span>
                                Veuillez envoyer de l'argent sur notre compte bancaire: <br/><span className="poppins-semibold">00009 - 05042 24550580005 23</span>
                              </span>
                            </li>
                            <li>
                              <span>
                                Montant du virement bancaire: <span className="poppins-semibold">{montantPay} MGA</span>
                              </span>
                            </li>
                            <li>
                              <span>
                                Description du virement bancaire: <span className="poppins-semibold">Paiement de la commande ECO-{numFact}</span>
                              </span>
                            </li>
                          </ul>
                        </div>
                      )
                    }
                  </div>
                  <div className="mt-4 sm:px-2">
                    <button
                      type="button"
                      className={`w-full flex justify-center py-2 px-4 transition-all duration-300 border border-transparent poppins-bold rounded-md text-white focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out ${
                        loading
                          ? "bg-pink-300 cursor-not-allowed"
                          : "bg-black hover:bg-pink-700 cursor-pointer"
                      }`}
                      onClick={closeModal}
                    >
                      {loading ? (
                        <span className="loading loading-ring loading-md"></span>
                      ) : (
                        <span>Continuer vos achats</span>
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default PaymentForm;
